const setupMainNav = ($) => {
  const mainNav = $('.main-nav');
  mainNav.on('init', function () {
    const mainActive = $('.main-nav .cm-menu').find('> .active');
    const activeList = mainActive.find(' > ul');
    const rootItems = mainActive.find('.mega-menu__item--root');

    if (!activeList.children('.active').length) {
      const landing = mainActive.find('.link-landing a');
      landing.addClass('active');
    }

    rootItems.each(function () {
      const subMenu = $(this).find('> .mega-menu__sub-menu');
      $(this).hover(function () {
        subMenu.attr('aria-expanded', 'true');
        $(this).focus();
      });

      $(this).mouseleave(function () {
        subMenu.attr('aria-expanded', 'false');
      });
    });
  });

  // @ts-ignore
  mainNav.clickMenu({ menutype: 'mega', expanders: false, landings: true });
};

export { setupMainNav };
